import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'

function Project() {
  return (
    <div>
        <Header />
            {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover"  style={{
    backgroundImage: "url('/assets/img/breadcrumb-bg.jpg')"

  }}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Our Projects</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="index-2.html">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                          Our Projects
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {/* <!-- Propertie Section Start --> */}
        <section class="propertie-section fix section-padding section-bg">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <div class="propertie-box-image">
                            <img src="assets/img/inner-page/project/project-01.jpg" alt="img"/>
                            <img src="assets/img/inner-page/project/project-01.jpg" alt="img"/>
                            <div class="propertie-content-item">
                                <div class="propertie-title">
                                    <span>13 Properties</span>
                                    <h3><a href="project-details.html">New York</a></h3>
                                </div>
                                <a href="project-details.html" class="link-btn">
                                    View Details <i class="flaticon-home"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <div class="propertie-box-image">
                             <img src="assets/img/inner-page/project/project-02.jpg" alt="img"/>
                             <img src="assets/img/inner-page/project/project-02.jpg" alt="img"/>
                            <div class="propertie-content-item">
                                <div class="propertie-title">
                                    <span>13 Properties</span>
                                    <h3><a href="project-details.html">New York</a></h3>
                                </div>
                                <a href="project-details.html" class="link-btn">
                                    View Details <i class="flaticon-home"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6">
                        <div class="propertie-box-image">
                             <img src="assets/img/inner-page/project/project-03.jpg" alt="img"/>
                             <img src="assets/img/inner-page/project/project-03.jpg" alt="img"/>
                            <div class="propertie-content-item">
                                <div class="propertie-title">
                                    <span>13 Properties</span>
                                    <h3><a href="project-details.html">New York</a></h3>
                                </div>
                                <a href="project-details.html" class="link-btn">
                                    View Details <i class="flaticon-home"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6">
                        <div class="propertie-box-image">
                             <img src="assets/img/inner-page/project/project-04.jpg" alt="img"/>
                             <img src="assets/img/inner-page/project/project-04.jpg" alt="img"/>
                            <div class="propertie-content-item">
                                <div class="propertie-title">
                                    <span>13 Properties</span>
                                    <h3><a href="project-details.html">New York</a></h3>
                                </div>
                                <a href="project-details.html" class="link-btn">
                                    View Details <i class="flaticon-home"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6">
                        <div class="propertie-box-image">
                             <img src="assets/img/inner-page/project/project-05.jpg" alt="img"/>
                             <img src="assets/img/inner-page/project/project-05.jpg" alt="img"/>
                            <div class="propertie-content-item">
                                <div class="propertie-title">
                                    <span>13 Properties</span>
                                    <h3><a href="project-details.html">New York</a></h3>
                                </div>
                                <a href="project-details.html" class="link-btn">
                                    View Details <i class="flaticon-home"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-7 col-lg-7 col-md-6">
                        <div class="propertie-box-image">
                             <img src="assets/img/inner-page/project/project-06.jpg" alt="img"/>
                             <img src="assets/img/inner-page/project/project-06.jpg" alt="img"/>
                            <div class="propertie-content-item">
                                <div class="propertie-title">
                                    <span>13 Properties</span>
                                    <h3><a href="project-details.html">New York</a></h3>
                                </div>
                                <a href="project-details.html" class="link-btn">
                                    View Details <i class="flaticon-home"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-6">
                        <div class="propertie-box-image height-style">
                            <img src="assets/img/inner-page/project/project-07.jpg" alt="img"/>
                            <img src="assets/img/inner-page/project/project-07.jpg" alt="img"/>
                            <div class="propertie-content-item">
                                <div class="propertie-title">
                                    <span>13 Properties</span>
                                    <h3><a href="project-details.html">New York</a></h3>
                                </div>
                                <a href="project-details.html" class="link-btn">
                                    View Details <i class="flaticon-home"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer />
    </div>
  )
}

export default Project